import type { ReactNode } from 'react';
import { theme } from 'antd';

interface StatCellProps {
  label: string;
  /** 'lg' bumps the value to heading-4 size (publications hero look). */
  size?: 'lg';
  children?: ReactNode;
}

/** Label-over-value cell for show hero headers. */
export const StatCell = ({ label, size, children }: StatCellProps) => {
  const { token } = theme.useToken();
  return (
    <div>
      <div
        style={{
          fontSize: token.fontSizeSM,
          color: token.colorTextTertiary,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize:
            size === 'lg' ? token.fontSizeHeading4 : token.fontSizeHeading5,
          lineHeight:
            size === 'lg' ? token.lineHeightHeading4 : token.lineHeightHeading5,
          marginTop: token.marginXXS,
        }}
      >
        {children}
      </div>
    </div>
  );
};
